<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Card>
        <template #title="">
          <div class="p-d-flex p-justify-between">
            หลักสูตร
            <div>
              <Button label="บันทึก" icon="pi pi-save" @click="onSaveCourse">
              </Button>
              <back-button class="p-ml-2" />
            </div>
          </div>
        </template>
        <template #content>
          <div class="p-grid">
            <div class="p-col-2 p-fluid">
              <span class="p-float-label">
                <InputText
                  id="courseId"
                  type="text"
                  v-model="course.id"
                  disabled="true"
                  maxlength="10"
                />
                <label for="courseId">รหัส</label>
              </span>
            </div>
            <div class="p-col-4 p-fluid">
              <span class="p-float-label">
                <InputText
                  id="description"
                  type="text"
                  v-model="course.description"
                  maxlength="100"
                />
                <label for="description">ชื่อหลักสูตร</label>
              </span>
            </div>
            <div class="p-col-2 p-fluid">
              <span class="p-float-label">
                <InputText
                  id="courseTypeId"
                  type="text"
                  v-model="course.courseTypeId"
                  disabled="true"
                  maxlength="3"
                />
                <label for="courseTypeId">ประเภทหลักสูตร</label>
              </span>
            </div>
            <div class="p-col-4 p-fluid">
              <span class="p-float-label">
                <InputText
                  id="courseTypeId"
                  type="text"
                  v-model="course.courseTypeId"
                  :value="course?.courseType?.description"
                  disabled="true"
                  maxlength="3"
                />
                <label for="courseTypeId">ประเภทหลักสูตร</label>
              </span>
            </div>
          </div>
        </template></Card
      >
    </div>
    <div class="p-col-12">
      <TrainingDocumentList
        :items="trainingDocumentDetailDto"
        :course="course"
        v-if="course.id"
      ></TrainingDocumentList>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import {
  Course,
  CourseType,
  GetCourseTypeResponse,
  TrainingTypeEnum,
  UpsertCourseRequest,
  CourseDetailDto,
  TrainingDocumentDetailDto,
} from "@/types";
import { usePlugin } from "@/plugins";
import TrainingDocumentList from "../../components/TrainingDocumentList.vue";
import { useQRCode } from "@vueuse/integrations";
import BackButton from "@/components/BackButton.vue";
export default defineComponent({
  components: { TrainingDocumentList, BackButton },
  name: "CourseMaintain",
  setup() {
    const { success, error, axios, setLoading, padZero, route } = usePlugin();
    let courseTypes = ref<CourseType[]>([]);
    const course = ref<Course>({} as Course);
    const trainingDocumentDetailDto = ref<TrainingDocumentDetailDto[]>([]);

    const loadCourseTypes = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetCourseTypeResponse>(
          "api/v1/services/courseType/get"
        );
        courseTypes.value = result.data.courseTypes ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const loadCourse = async () => {
      if (route.params.id) {
        setLoading(true);
        try {
          const result = await axios.get<CourseDetailDto>(
            `api/v1/services/course/${route.params.id}`
          );
          course.value = result.data.course ?? ({} as Course);
          trainingDocumentDetailDto.value =
            result.data.trainingDocumentDtos ?? [];
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onSaveCourse = async () => {
      if (course.value.id && course.value.id.length > 0) {
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/course/upsert", {
            courses: [
              {
                id: padZero(course.value.id, 7),
                description: course.value.description,
                courseTypeId: course.value.courseTypeId,
              },
            ],
          } as UpsertCourseRequest);
          await loadCourse();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          // showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    onMounted(async () => {
      await loadCourseTypes();
      await loadCourse();
    });

    return {
      courseTypes,
      course,
      onSaveCourse,
      TrainingTypeEnum,
      trainingDocumentDetailDto,
      loadCourse,
    };
  },
});
</script>

<style></style>
